import styled from 'styled-components'

import { _S_Normal, _XS_Bold, _XS_Medium, _XS_Normal, mainColors } from '@avantstay/backoffice-core'

export const Root = styled.div`
  border: 1px solid ${mainColors.neutralMedium};
  border-radius: 12px;
  background: ${mainColors.white};
  margin: 12px 0;
`

export const Head = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 8px 12px;
  border-bottom: 1px solid ${mainColors.neutralMedium};
`

export const Chip = styled.span`
  ${_XS_Bold};
  color: ${mainColors.white};
  background: ${mainColors.primaryMedium};
  border-radius: 4px;
  padding: 0 4px;
  letter-spacing: 0.05em;
  flex: none;
`

export const Topic = styled.span`
  ${_XS_Bold};
  color: ${mainColors.primaryMedium};
  overflow-wrap: anywhere;
`

export const Spacer = styled.span`
  flex: 1;
`

export const When = styled.span`
  ${_XS_Normal};
  color: ${mainColors.neutralExtremelyDark};
  flex: none;
`

export const Summary = styled.p`
  ${_S_Normal};
  color: ${mainColors.neutralExtremelyDark2};
  line-height: 1.55;
  margin: 0;
  padding: 8px 12px;
  overflow-wrap: anywhere;
`

export const Footer = styled.div`
  ${_XS_Normal};
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 0 12px 8px;
  color: ${mainColors.neutralExtremelyDark};
  overflow-wrap: anywhere;
`

export const NoTranscript = styled.span`
  ${_XS_Normal};
  color: ${mainColors.neutralExtremelyDark};
  font-style: italic;
`

export const Toggle = styled.button`
  ${_XS_Medium};
  border: 1px solid ${mainColors.neutralDark};
  background: ${mainColors.white};
  color: ${mainColors.primaryMedium};
  border-radius: 8px;
  padding: 4px 8px;
  cursor: pointer;
`

export const Link = styled.a`
  ${_XS_Medium};
  color: ${mainColors.accentDark};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

export const Transcript = styled.pre`
  ${_S_Normal};
  color: ${mainColors.neutralExtremelyDark2};
  line-height: 1.6;
  margin: 0;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`

export const TranscriptBody = styled.div`
  padding: 12px;
  margin: 0 12px 12px;
  background: ${mainColors.neutralLight};
  border-radius: 8px;
`

export const Turn = styled.div`
  display: flex;
  gap: 12px;

  & + & {
    margin-top: 12px;
  }
`

export const TurnSpeaker = styled.span<{ $isGuest: boolean }>`
  ${_XS_Bold};
  flex: none;
  width: 116px;
  padding-top: 4px;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ $isGuest }) => ($isGuest ? mainColors.primaryLight : mainColors.accentExtraDark2)};
`

export const TurnText = styled.span`
  ${_S_Normal};
  color: ${mainColors.neutralExtremelyDark2};
  line-height: 1.6;
  max-width: 70ch;
  overflow-wrap: anywhere;
`

export const TranscriptNote = styled.p`
  ${_XS_Normal};
  color: ${mainColors.neutralExtremelyDark};
  line-height: 1.5;
  margin: 16px 0 0;
`
